import { makeAutoObservable } from "mobx";
import { getUserInfo } from "@/services/YsApi/account";
class YSStore {
  role_id = ""; // 1:管理员 2:客服 cs 3:销售 sales 4:客服主管 cs_supervisor staff: 员工
  user_name = "";
  identity = ""; //agent 代理商主账号 staff 员工账号
  constructor() {
    makeAutoObservable(this);
  }
  public getUserInfo() {
    getUserInfo()
      .then((res) => {
        this.role_id = res.data.item.role_id;
        this.identity = res.data.item.identity;
        this.user_name = res.data.item.username;
      })
      .catch((e) => {
        console.log(e);
      });
  }
}
const store = new YSStore();
export default store;
